import {NgModule, ErrorHandler} from '@angular/core';

import {CommonModule} from '@angular/common';

import {FormsModule} from '@angular/forms';
import {HttpModule} from '@angular/http';
import {ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';

import 'rxjs/Rx';

// import 'hammerjs';
import {AllMaterialModule} from '../../all-material.module';

// components
import {BallotDialogComponent} from './components/ballot-dialog/ballot-dialog.component';
import {DialogComponent} from './components/dialog/dialog.component';
import {EmailComponent} from './components/email/email.component';
import {ExpandComponent} from './components/expand/expand.component';
import {FeedbackComponent} from './components/feedback/feedback.component';
import {FilmComponent} from './components/film/film.component';
import {FilmmakerLetterComponent} from './components/filmmaker-letter/filmmaker-letter.component';
import {FilmReviewComponent} from './components/film-review/film-review.component';
import {GridBlockComponent} from './components/grid-block/grid-block.component';
import {HelpFaqComponent} from './components/help-faq/help-faq.component';
import {ListPageComponent} from './components/list-page/list-page.component';
import {NavigateComponent} from './components/navigate/navigate.component';
import {NoteComponent} from './components/note/note.component';
import {PageComponent} from './components/page/page.component';
import {SidenavComponent} from './components/sidenav/sidenav.component';
import {ScrollContainerComponent} from './components/scroll-container/scroll-container.component';
import {ScrollItemComponent} from './components/scroll-item/scroll-item.component';
import {ScrollSentinalComponent} from './components/scroll-sentinal/scroll-sentinal.component';
import {ScrollToTopComponent} from './components/scroll-to-top/scroll-to-top.component';
import {ScrollTombstoneComponent} from './components/scroll-tombstone/scroll-tombstone.component';
import {ScrollTombstoneMeasureComponent} from './components/scroll-tombstone-measure/scroll-tombstone-measure.component';
import {UserComponent} from './components/user/user.component';
import {UserEditComponent} from './components/user-edit/user-edit.component';
import {ViewComponent} from './components/view/view.component';
import {VersionComponent} from './components/version/version.component';
import {VoteDialogComponent} from './components/vote-dialog/vote-dialog.component';
import {WatchFilmComponent} from './components/watch-film/watch-film.component';



// pipes
import {MinutesPipe} from './pipes/minutes.pipe';
import {PhonePipe} from './pipes/phone.pipe';

// directives
import {ItdDraggableDirective} from './directives/itd-draggable.directive';
import {ItdDroppableDirective} from './directives/itd-droppable.directive';
import {ItdHeightFromWidthDirective} from './directives/itd-height-from-width.directive';
import {ItdInfiniteScrollDirective} from './directives/itd-infinite-scroll.directive';
import {SetFocusDirective} from './directives/set-focus.directive';
import {TrackScrollDirective} from './directives/track-scroll.directive';

// classes
// import {Film} from './classes/film';
// import {User} from './classes/user';
// import {ItdExceptionHandler} from './classes/itd-exception';


@NgModule({
	imports: [
		AllMaterialModule,
		CommonModule,
		FormsModule,
		HttpModule,
		ReactiveFormsModule,
		RouterModule,
	],
	declarations: [
		// components
		BallotDialogComponent,
		DialogComponent,
		EmailComponent,
		ExpandComponent,
		FeedbackComponent,
		FilmComponent,
		FilmmakerLetterComponent,
		FilmReviewComponent,
		GridBlockComponent,
		HelpFaqComponent,
		ListPageComponent,
		NavigateComponent,
		NoteComponent,
		PageComponent,
		SidenavComponent,
		ScrollContainerComponent,
		ScrollItemComponent,
		ScrollSentinalComponent,
		ScrollToTopComponent,
		ScrollTombstoneComponent,
		ScrollTombstoneMeasureComponent,
		UserComponent,
		UserEditComponent,
		ViewComponent,
		VersionComponent,
		VoteDialogComponent,
		WatchFilmComponent,

		// pipes
		MinutesPipe,
		PhonePipe,

		// directives
		ItdDraggableDirective,
		ItdDroppableDirective,
		ItdHeightFromWidthDirective,
		ItdInfiniteScrollDirective,
		SetFocusDirective,
		TrackScrollDirective

		// classes
		// Film,
		// User,
		// ItdExceptionHandler
	],
	exports: [
		// components
		BallotDialogComponent,
		DialogComponent,
		EmailComponent,
		ExpandComponent,
		FeedbackComponent,
		FilmComponent,
		FilmmakerLetterComponent,
		FilmReviewComponent,
		GridBlockComponent,
		HelpFaqComponent,
		ListPageComponent,
		NavigateComponent,
		NoteComponent,
		PageComponent,
		SidenavComponent,
		ScrollContainerComponent,
		ScrollItemComponent,
		ScrollSentinalComponent,
		ScrollToTopComponent,
		ScrollTombstoneComponent,
		ScrollTombstoneMeasureComponent,
		UserComponent,
		UserEditComponent,
		ViewComponent,
		VersionComponent,
		VoteDialogComponent,
		WatchFilmComponent,

		// pipes
		MinutesPipe,
		PhonePipe,

		// directives
		ItdDraggableDirective,
		ItdDroppableDirective,
		ItdHeightFromWidthDirective,
		ItdInfiniteScrollDirective,
		SetFocusDirective,
		TrackScrollDirective,

		// classes
		// Film,
		// User,
		// ItdExceptionHandler
	]
})
export class SharedModule {}



// WEBPACK FOOTER //
// /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/modules/shared/shared.module.ts